import React from 'react';
import Barcode from 'react-barcode';

// Bu component, etiket şablonunu oluşturur.
function EtiketSablonu({ siparis, ozelBarkod, isEkPaket, paketSiraNo }) {

    // Gönderici bilgileri sabit ve büyük harfli olarak kodlandı.
    const gondericiBilgileri = {
        ad_soyad: "OKAN PEKMEZCİ",
        adres: "ERZURUM MAH. DUMLUPINAR CAD. GÜL SOK. NO:2",
        ilce_il: "ÇANKAYA / ANKARA",
    };

    // Stiller, yeni tasarıma göre güncellendi.
    const styles = {
        etiket: {
            width: '12cm',
            height: '9cm',
            padding: '0.3cm',
            border: '1px solid black',
            fontFamily: 'Arial, sans-serif',
            fontSize: '10pt',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            boxSizing: 'border-box',
            color: 'black',
            backgroundColor: 'white'
        },
        bolum: {
            padding: '0.05cm 0',
            borderBottom: '1px solid black',
        },
        ustBilgi: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start', // Dikeyde üste hizala
            fontSize: '10pt',
            flexDirection: 'column' // Alt alta gelmesi için
        },
        adresBolumu: {
            padding: '0.2cm 0',
            fontSize: '10pt',
        },
        adresSatiri: {
            marginBottom: '0.1cm' // Adres satırları arası boşluk
        },
        adresBosluk: {
            height: '0.4cm' // İstenen bir satır boşluk
        },
        barkodBolumu: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0.2cm 0',
        },
        barkodNo: {
            fontWeight: 'bold',
            fontSize: '16pt',
            letterSpacing: '1.5px',
        },
        ekHizmet: {
            fontSize: '10pt',
            textAlign: 'right'
        },
        altDetay: {
            display: 'flex',
            justifyContent: 'space-between',
            paddingTop: '0.2cm',
        },
    };

    if (!siparis) {
        return null;
    }

    // Alıcı bilgilerini güvenli bir şekilde al
    const alici = siparis.musteri || siparis;
    
    // Eğer özel bir barkod gönderildiyse onu kullan, yoksa siparişin ana barkodunu kullan
    const efektifBarkod = ozelBarkod || siparis.kargo_takip_no;
    
    // Kapıda ödeme sadece ana barkodda ve ödeme yöntemi 'K' ise gösterilir
    // Ek paket ise kapıda ödeme gösterilmez
    const isKapidaOdemeGoster = siparis.odeme_yontemi === 'K' && !isEkPaket;
    
    // Alıcı ödemeli durumunu localStorage'dan kontrol et
    const isAliciOdemeli = localStorage.getItem(`kargo_alici_odemeli_${siparis.id}`) === 'true';
    
    // Özel baskı ürünü var mı kontrol et
    const hasOzelBaski = siparis.sepet && siparis.sepet.some(urun => 
        urun.urun_tipi === 'Özel Baskı'
    );

    return (
        <div style={styles.etiket}>
            
            {/* --- 1. BÖLÜM: Üst Bilgi (GÜNCELLENDİ) --- */}
            <div style={{...styles.bolum, ...styles.ustBilgi, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start'}}>
                {/* Sol Taraf */}
                <div>
                    <div style={{fontWeight: 'bold', fontSize: '12pt'}}>PTT A.Ş</div>
                    <div style={{fontWeight: 'regular', fontSize: '8pt', paddingTop: '0.1cm'}}>
                        <strong>Referans No:</strong>
                    </div>
                </div>
                {/* Sağ Taraf */}
                <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                    {/* Özel Baskı İndikatörü */}
                    {hasOzelBaski && (
                        <div style={{
                            backgroundColor: 'black',
                            color: 'white',
                            fontSize: '20pt',
                            fontWeight: 'bold',
                            padding: '1px 6px',
                            borderRadius: '3px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            ÖB
                        </div>
                    )}
                    <div style={{fontSize: '20pt', fontWeight: 'bold'}}>
                        {(alici.telefon_numarasi || '----').slice(-4)}
                        {paketSiraNo && ` (${paketSiraNo})`}
                    </div>
                </div>
            </div>

            {/* 2. BÖLÜM: Gönderici */}
            <div style={{...styles.bolum, ...styles.adresBolumu, display: 'flex'}}>
                <div style={{
                    fontSize: '8pt', 
                    textDecoration: 'underline', 
                    writingMode: 'vertical-rl',
                    textOrientation: 'mixed',
                    transform: 'rotate(180deg)',
                    marginRight: '20px',
                    marginLeft: '-5px',
                    paddingTop: '5px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>Gönderici</div>
                <div style={{flex: 1, marginLeft: '-10px'}}>
                    <div style={styles.adresSatiri}>{(gondericiBilgileri.ad_soyad || '').toUpperCase()}</div>
                    <div style={styles.adresSatiri}>{(gondericiBilgileri.adres || '').toUpperCase()}</div>
                    <div style={styles.adresBosluk}></div> {/* Boşluk */}
                    <div style={styles.adresSatiri}>{(gondericiBilgileri.ilce_il || '').toUpperCase()}</div>
                </div>
            </div>

            {/* 3. BÖLÜM: Barkod ve Ek Hizmetler */}
            <div style={{...styles.bolum, ...styles.barkodBolumu}}>
                <div style={styles.barkodNo}>
                    {efektifBarkod ? (
                        <Barcode 
                            value={efektifBarkod} 
                            width={1.5}      // Çubukların kalınlığı
                            height={30}    // Barkodun yüksekliği
                            displayValue={true} // Takip numarasını altında metin olarak da göster
                            fontSize={14}  // Altındaki metnin boyutu
                            margin={2}
                        />
                    ) : (
                        <span>TAKİP NO BEKLENİYOR</span>
                    )}
                </div>
                <div style={styles.ekHizmet}>
                    <strong>Ek Hizmetler:</strong><br/>
                    {/* Kapıda ödeme durumu - Sadece ana barkodda göster */}
                    {isKapidaOdemeGoster && (
                        <div>ÖDEME ŞARTLI - {(siparis.toplam_bedel || 0).toFixed(2)} TL</div>
                    )}
                    {/* Alıcı ödemeli kargo durumu */}
                    {isAliciOdemeli && (
                        <div style={{marginTop: '2px'}}>ÜCRETİ ALICIDAN TAHSİL</div>
                    )}
                </div> 
            </div>

            {/* 4. BÖLÜM: Alıcı ve Alt Detaylar */}
            <div>
                <div style={{...styles.bolum, ...styles.alici, display: 'flex'}}>
                    <div style={{
                        fontSize: '8pt', 
                        textDecoration: 'underline', 
                        writingMode: 'vertical-rl',
                        textOrientation: 'mixed',
                        transform: 'rotate(180deg)',
                        marginRight: '20px',
                        marginLeft: '-5px',
                        paddingTop: '5px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>Alıcı</div>
                    <div style={{flex: 1, marginLeft: '-10px'}}>
                        <div style={styles.adresSatiri}>{(alici.ad_soyad || '').toUpperCase()}</div>
                        <div style={styles.adresSatiri}>{(alici.adres || '').toUpperCase()}</div>
                        <div style={styles.adresBosluk}></div> {/* Boşluk */}
                        <div style={styles.adresSatiri}>{(alici.ilce || '').toUpperCase()} / {(alici.il || '').toUpperCase()}</div>
                    </div>
                </div>
                <div style={styles.altDetay}>
                    <div><strong>Ödeme Şekli:</strong></div>
                    {/* Ağırlık / desi değeri boş bırakılır (elle doldurulur) */}
                    <div><strong>Ağırlık/Desi:</strong></div>
                </div>
            </div>
        </div>
    );
};

export default EtiketSablonu;